import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/swiper.scss';
import Button from "../../../module/button";
import history from "../../../route/history";
import {commons} from "../../../hook/common";
import { isMobile,isBrowser } from 'react-device-detect'
import * as device from 'react-device-detect'
import * as Common from '../../../assets/js/common';
import {getDeviceType} from '../../../assets/js/common';
import { govCertapplyActions, regisActions, userinfoActions,authActions } from '../../../store/actions';
import { uriConstants } from '../../../store/constants';
import authHeader from '../../../module/auth-header'
import axios from 'axios';
import KTnetModal3 from '../../../module/ktnet/KTnetModal3';
import moment from 'moment'

const MobileGuide = props => {
    const totalSlide = 4;
    const [ current, setCurrent] = useState(0);
    const [ json, setJson] = useState('');
    const [ json2, setJson2] = useState('');
    const [ urlParam, setUrlParam] = useState({signedData:'',ecdwAdres:'',urlCode:'030100'});
    const [ signedData, setSignedData] = useState('');
    const [ url, setUrl] = useState('start!!!');
    const [ open,setOpen] = useState(false)
    useEffect(()=>{
        window.addEventListener('message',messageFunc,false)
        return ()=>{
            window.removeEventListener('message',messageFunc,false)
        }
    },[])
    const messageFunc = (e)=>{
        if (e?.data?.message){
            let a = e?.data?.data
            setSignedData(a)
            props.setSignData(a)
            urlParam.signedData=a;
            // setUrlParam({
            //     ...urlParam,
            //     signedData :a,
            // })

            console.log(JSON.stringify(urlParam))
            setJson2('{"signedData":"'+a+'", "ecdwAdres":"","urlCode":"030100"}')
            console.log(a)
        }
    }
    useEffect(() => {
        // console.log(isMobile)
        // console.log(device)
        // console.log(Common)
        // console.log(Common.getDeviceType())
        // console.log(getDeviceType)
        // console.log(getDeviceType())
        // console.log(navigator.userAgent)
        // console.log(window.ReactNativeWebView)
        // console.log(commons.isMobile())
        json ==='123' && console.log("123")
        if (json ==='open!'){
            setOpen=true
        }
    }, [json])

    // subscribe
    useEffect(()=>{
        console.log(props.screenURL?.url)
        console.log(props.verifyIndiECDWResult)
        if(props.verifyIndiECDWResult?.ecdwAdres){
            urlParam.ecdwAdres =props.verifyIndiECDWResult?.ecdwAdres;
            // setUrlParam({
            //     ...urlParam,
            //     ecdwAdres : props.verifyIndiECDWResult?.ecdwAdres
            // })
        }
        // ecdwAdres
    },[props.screenURL,props.verifyIndiECDWResult])

    const myheader ={
        'Content-type': 'application/json; charset=UTF-8',
      }
    const goStart = () => {
        if (commons.isMobile()) {
            //최초실행 저장
            window.ReactNativeWebView.postMessage(JSON.stringify({storage: {isFirst: 'true'}}));
        }
        history.replace('/login');
    }
    const button1 =()=>{
        let paramStr = JSON.parse(json)
        axios.post(uriConstants.API_URI+'/portal/blockchain/test',paramStr,{headers:myheader}).then((res)=>{
            console.log(res)
        }).catch((err)=>{
            console.log(err)
        })
    }
    const button2 =()=>{
        let paramStr = JSON.parse(json)
        axios.post(uriConstants.API_URI+'/portal/blockchain/test',paramStr,{headers:myheader,data : paramStr}).then((res)=>{
            console.log(res)
          }).catch((err)=>{
            console.log(err)
          })
    }
    const button3 =()=>{
        let paramStr = JSON.parse(json)
        axios.post(uriConstants.API_URI+'/portal/blockchain/test2',paramStr,{headers:myheader,data : paramStr}).then((res)=>{
            console.log(res)
          }).catch((err)=>{
            console.log(err)
          })
    }
    const button4 =()=>{
        let paramStr = JSON.parse(json)
        console.log(paramStr)
        console.log(uriConstants.API_URI+'/portal/blockchain/logTest')
        axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',paramStr,{headers:{}})
    }
    const button5 =()=>{
        const queryString = require('query-string')
        let paramStr = queryString.stringify(json)

        
        axios.get(uriConstants.API_URI+'/portal/blockchain/test2'+paramStr,myheader).then((res)=>{
            console.log(res)
          }).catch((err)=>{
            console.log(err)
          })
    }
    const button6 =()=>{
    
        setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + json
        console.log(url)
        let xhr = new XMLHttpRequest()
        xhr.responseType = 'blob'
        xhr.open('GET', url)
        xhr.send()
        xhr.onload = function () {
            url = window.URL.createObjectURL(xhr.response)
            window.open('/pdfViewer/pdfViewer.html?file=' + url, '_blank')
            setUrl(url)
            //   }
        }
        
        // pdf 뷰어를 열게되면 새로고침 실행
        xhr.onloadend = ()=>{
            setTimeout(()=>{
                window.location.reload();
            },1000)
        }
        }, 20)
    
    }
    const button7 =() =>{
            initXHR().then((res)=>{
                window.location.reload()
            })
    }
    const button8 =() =>{ // toolkit 열기JSON
        let p = '';
        if(json){
            p = json
        }else{
            p = urlParam.ecdwAdres
        }
        window.open('/nxts/install/pki/openToolkit4.htm'+p, 'ktnetWindow', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=300, height=330, left=400, top=400`);
    }
    const button9 =() =>{ // 스크린 URL 가져오기
        // const params = {
            //     signedData: signedData,
            //     ecdwAdres: '12JK79Ep64tDynn7GdvYqxZwgD3hCao9tuYm2Frk', //
            //     urlCode: paramUrlCode, // 필요
            //     deviceId:deviceId // 이건 모르겠음...
            //   }
            const params2 = JSON.parse(json2)
            props.getScreenURL(params2)
    }
    const button10 =() =>{ // 정부24지갑주소 가져오기 JSON
        const params = {
            // deviceId: deviceId,
            // ci: user.certCi,
            // moblphonNo: user.mobileNo,
          }
        const param = JSON.parse(json)
        console.log(param)
        let testParam = {ci:param.ci,moblphonNo:param.moblphonNo}
        props.verifyIndiECDW(testParam)
    }
    const button11 =() =>{ // 서버에서 signdata 만들기 JSON값 사용
        let paramStr = JSON.parse(json)
        axios.post(uriConstants.API_URI+'/portal/egov/ScreenURLRequest2',paramStr,{headers:myheader}).then((res)=>{
            console.log(res)
        }).catch((err)=>{
            console.log(err)
        })
    }
    const button12 =() =>{ // 서버에 로그남기기
        let paramStr = JSON.parse(json)
        axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',paramStr,{headers:{},data : paramStr})
    }
    const button13 =() =>{ // 모피어스로 uuid 만들기 테스트 -> 테스트에서는 동작중...
        let regex1 = /^\?/g
        console.log(Common.getDeviceType())
        if (Common.getDeviceType()=='MobileApp'){
            console.log(window.M.info.device(json))
            console.log(window.M.info)
        }
    }
    let head = {a:'b'}
    const button14 = ()=>{
        // console.log(window.M.info.device(json))
        // console.log(window.M.info)
        if(json =='reset'){
            head = {}
        }
        Object.assign(head,JSON.parse(json))
        Object.assign(head,authHeader())

        console.log(head)
    }
    const button15 = ()=>{
        
        props.setSignData(json)
        console.log(props.userinfo)
    }
    const button17 = ()=>{
        let a = Date.now()
        let b = moment('2022-07-09').format('YYYYMMDD')
        console.log(a)
        console.log(b)
        console.log(moment())
        console.log(moment().format('YYYYMMDD'))
        
    }
    const button18 = async ()=>{
        props.passCrtfctfLoginTest(json,'1','Y',temp)
    }
    const button19 = ()=>{
        
        props.setSignData(json)
        console.log(props.userinfo)
    }

    const button20 = ()=>{
        async function getEcdeAdress(rawJson){
            var myHeaders = new Headers()
            myHeaders.append('Content-Type', 'application/json')
            myHeaders.append('Accept', 'application/json')

            let raw = JSON.stringify(rawJson)
            var requestOptions = {
              method: 'POST',
              headers: {'Content-Type': 'application/json','Accept': 'application/json'},
              body: raw,
              redirect: 'follow',
            }
            console.log(requestOptions)
            let a = await fetch(uriConstants.API_URI + uriConstants.VERIFY_INDI_ECDW, requestOptions)
              .then((response) => response.text())
              .then((result) => {
                JSON.parse(result)
              })
              console.log(a)
              return a
          }
        const param = JSON.parse(json)
        console.log(param)
        let testParam = {ci:param.ci,moblphonNo:param.moblphonNo}
        console.log(getEcdeAdress(param))
        // getEcdeAdress(testParam)
    }
    async function temp(param){
        let a = await axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',param,{headers:{},data : param});
        console.log(a)
        return a.status
    }
    useEffect(()=>{
        console.log(props.signData)
    },[props.signData])
    const initXHR = ()=>{
        return new Promise((resolve,reject)=>{
            try{
                let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + json
                let xhr = new XMLHttpRequest()
                xhr.responseType = 'blob'
                xhr.open('GET', url)
                xhr.send()
                xhr.onload = function () {
                    url = window.URL.createObjectURL(xhr.response)
                    window.open('/pdfViewer/pdfViewer.html?file=' + url, '_blank')
                    resolve(xhr.response)
                }
            }catch(err){
                reject(err.message)
            }
        })
    }
    return (
        <React.Fragment>
            <div className="mobile-intro-box">
               <div className="list-num">
                    <span className={current === 0 ? 'active': ''} style={{ display: 'inline-block', width: '4rem'}}> 1 </span>
                    <span className={current === 1 ? 'active': ''} style={{ display: 'inline-block', width: '4rem'}}> 2 </span>
                    <span className={current === 2 ? 'active': ''} style={{ display: 'inline-block', width: '4rem'}}> 3 </span>
                    <span className={current === 3 ? 'active': ''} style={{ display: 'inline-block', width: '4rem'}}> 4 </span>
               </div>

                            <Swiper
                                spaceBetween={50}
                                slidesPerView={1}
                                style={{height:'100%'}}
                                onSlideChange={(swiper) => setCurrent(swiper.activeIndex)}
                                onSwiper={(swiper) => console.log(swiper)}
                            >
                                <SwiperSlide className="intro1">
                                </SwiperSlide>
                                <SwiperSlide className="intro2">
                                    Slide 2
                                </SwiperSlide>
                                <SwiperSlide  className="intro3">
                                    Slide 3
                                </SwiperSlide>
                                <SwiperSlide className="intro4">
                                    Slide 4
                                </SwiperSlide>
                            </Swiper>
                            {
                                current === 3 && <button className="btn-start" onClick={goStart}>시작하기</button>
                            }
            </div>
            <input type={'text'} id="json" onChange={e=>setJson(e.target.value)} ></input>
            <input type={'text'} id="json2" value={json2} onChange={e=>setJson2(e.target.value)} ></input>
            <div id="result">{url}</div>
            <button onClick={button1}>버튼1</button>
            <button onClick={button2}>버튼2</button>
            <button onClick={button3}>버튼3</button>
            <button onClick={button4}>버튼4</button>
            <button onClick={button5}>버튼5</button>
            <button onClick={button6}>버튼6</button>
            <button onClick={button7}>버튼7</button>
            <br/>
            <button onClick={button8}>버튼8</button>
            <button onClick={button9}>버튼9</button>
            <button onClick={button10}>버튼10</button>
            <button onClick={button11}>버튼11</button>
            <button onClick={button12}>버튼12</button>
            <br/>
            <button onClick={button13}>버튼13</button>
            <button onClick={button14}>버튼14</button>
            <br/>
            <button onClick={button15}>버튼15</button>
            <button onClick={()=>{history.replace('/')}}>버튼16</button>
            <button onClick={button17}>버튼17</button>
            <br/>
            <button onClick={button18}>버튼18</button>
            <button onClick={button19}>버튼19</button>
            <button onClick={button20}>버튼20</button>

        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        sign : state?.userinfo?.data?.signData,
        screenURL: state.govcertapply?.screenURL,
        verifyIndiECDWResult: state.govcertapply?.verifyIndiECDWResult,
        signData :  state?.userinfo?.signData,
        userinfo : state?.userinfo,
    }
}
const actionCreators = {
    getScreenURL:govCertapplyActions.getScreenURL,
    verifyIndiECDW:govCertapplyActions.verifyIndiECDW,
    setSignData : userinfoActions.setSignData,
    passCrtfctfLoginTest : authActions.passCrtfctfLoginTest,
}

export default connect(   mapStateToProps,  actionCreators)(MobileGuide)
